import { render, staticRenderFns } from "./Suspects.vue?vue&type=template&id=00070f14&scoped=true"
import script from "./Suspects.vue?vue&type=script&lang=js"
export * from "./Suspects.vue?vue&type=script&lang=js"
import style0 from "./Suspects.vue?vue&type=style&index=0&id=00070f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00070f14",
  null
  
)

export default component.exports